import http from 'plugins/axios';

export default {

    etpMerge(data) {
        return http.post({
            url: '/admin/etpMerge/merge',
            data,
            dataType: 'form'
        })
    },

    getEtpMargeList(data) {
        return http.get({
            url: '/admin/etpMerge/list',
            data
        });
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};
